import { gql } from '@apollo/client';
import { MEDIA_FIELD } from '../../fragments/fields/media';
import { COLUMNS_BLOCK, CONTENT_BLOCK, IMAGE_BLOCK } from '../../fragments/blocks';
import { CTA_BLOCK } from '../../fragments/blocks/Cta';

export const ARTICLE = gql`
  query Article($draft: Boolean, $where: Article_where) {
    Articles(draft: $draft, where: $where, limit: 1, page: 1, pagination: false) {
      docs {
        id
        title
        image {
          ...MediaFieldFragment
        }
        layout {
          ...ContentBlockFragment
          ...ImageBlockFragment
          ...ColumnsBlockFragment
          ...CtaBlockFragment
        }
        meta {
          title
          description
        }
        slug
        publishedAt
        author {
          id
          fullName
        }
        categories {
          id
          title
        }
        tags {
          id
          title
        }
        timeToRead
        updatedAt
        createdAt
        _status
      }
    }
  }
  ${CONTENT_BLOCK}
  ${IMAGE_BLOCK}
  ${MEDIA_FIELD}
  ${COLUMNS_BLOCK}
  ${CTA_BLOCK}
`;

export const ARTICLES = gql`
  query Articles($draft: Boolean, $where: Article_where, $limit: Int, $page: Int, $pagination: Boolean, $sort: String) {
    Articles(draft: $draft, where: $where, limit: $limit, page: $page, pagination: $pagination, sort: $sort) {
      docs {
        id
        title
        image {
          ...MediaFieldFragment
        }
        slug
        publishedAt
        author {
          id
          fullName
        }
        categories {
          id
          slug
          title
        }
        tags {
          id
          title
        }
        timeToRead
        excerpt
        updatedAt
        createdAt
        _status
      }
      hasNextPage
      hasPrevPage
      limit
      nextPage
      offset
      page
      pagingCounter
      prevPage
      totalDocs
      totalPages
    }
  }
  ${MEDIA_FIELD}
`;
